import React from 'react';
import './AppFooter.scss';
import config from 'config';

export class AppFooter extends React.Component {
  render () {
    const year = new Date().getFullYear();
    return (
      <div className='app-footer'>
        <div>
          {year} &copy;{' '}
          {config.isUat && process.env.REACT_APP_VERSION
            ? process.env.REACT_APP_VERSION.replace('-pchome', '')
            : process.env.REACT_APP_VERSION}
          <br />
          powered by TenMax
          <br />
        </div>
      </div>
    );
  }
}
